import styled, {css} from 'styled-components'

export const StyledLabel = styled.div`
    ${({theme: {typography, spacing}}) => css`
        margin-top: ${spacing * 2}px;
        font-weight: 700;
        ${typography.textMd};
    `}
`
